import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home/home";
import Investor from "./pages/investor/investor";
import Contact from "./pages/contact/contact";
import Founder from "./pages/founder/founder";
import Blog from "./pages/blog/blog";
import Pricing from "./pages/pricing/pricing";
import About from "./pages/about/about";
import Flow from "./pages/flow/flow";
import Demo from "./pages/demo/demo";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router basename="/">
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="investor" element={<Investor />} />
      <Route path="founder" element={<Founder />} />
      <Route path="contact" element={<Contact />} />
      <Route path="blog" element={<Blog />} />
      <Route path="about" element={<About />} />
      <Route path="pricing" element={<Pricing />} />
      <Route path="flow" element={<Flow />} />
       <Route path="demo" element={<Demo/>} />
      {/* <Route path="*" element={<Error/>} /> */}
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
